<template>
  <div class="wrapper perfect-theme-design">
    <!-- <div v-if="isUpdate"></div> -->
    <div class="content">
      <div class="title">必备品/排面数配置</div>
    </div>
    <div class="content">
      <div class="title">
        <div>
          <el-button style="margin-right:0" v-if="isCanUpdate || !isView" type="primary" size="mini" plain @click="handleAddRow()">新增</el-button>
        </div>
        <div :inline="true" :model="formDesign" class="demo-form-inline">
          <el-input class="iptSize" size="mini" v-model="formDesign.defineName" placeholder="套餐名称" style="width:120px;"></el-input>
          <el-select class="iptSize" size="mini" v-model="formDesign.stackPackSubBrands" filterable clearable placeholder="子品牌">
            <el-option v-for="item in subBrandOptions" :key="item.abiBrandId" :label="item.abiBrandName" :value="item.abiBrandCode"></el-option>
          </el-select>
          <el-button type="danger" size="mini" plain @click="onSubmit">搜索</el-button>
          <el-button type="primary" size="mini" plain @click="handleResst">重置</el-button>
        </div>
      </div>
    </div>
    <div v-if="mandatoryItemList.length">
      <div class="info">
        <el-row v-if="!isView" class="header" type="flex" align="middle" justify="center">
          <el-col :span="2">序号</el-col>
          <el-col :span="3"><span class="require">套餐名称</span></el-col>
          <el-col :span="19">
            <el-col :span="3"><span class="require">品牌</span></el-col>
            <el-col :span="3"><span class="require">子品牌</span></el-col>
            <el-col :span="3"><span class="require">容量</span></el-col>
            <el-col :span="3"><span class="require">是否多联包</span></el-col>
            <el-col :span="3"><span class="require">规格</span></el-col>
            <el-col :span="3"><span class="require">最小陈列件</span></el-col>
            <el-col :span="2"><span>排面数</span></el-col>
            <el-col :span="4"><span>操作</span></el-col>
          </el-col>
        </el-row>
        <el-row v-else class="header" type="flex" align="middle" justify="center">
          <el-col :span="2">序号</el-col>
          <el-col :span="3"><span>套餐名称</span></el-col>
          <el-col :span="19">
            <el-col :span="4"><span>品牌</span></el-col>
            <el-col :span="4"><span>子品牌</span></el-col>
            <el-col :span="3"><span>容量</span></el-col>
            <el-col :span="3"><span>是否多联包</span></el-col>
            <el-col :span="4"><span>规格</span></el-col>
            <el-col :span="3"><span>最小陈列件</span></el-col>
            <el-col :span="3"><span>排面数</span></el-col>
          </el-col>
        </el-row>
        <el-row
          style="overflow:auto; font-size: 14px; color: #606266"
          v-for="(mandatory, index) in mandatoryItemListPagination"
          :key="index"
          class="detail"
          type="flex"
          align="middle"
          justify="center"
        >
          <!-- <el-col :span="4">{{ mandatory.defineName }} </el-col> -->
          <el-col :span="2" style="display: flex; align-items: center; justify-content: center;">{{mandatory.sequenceFlag}}</el-col>
          <el-col :span="3" style="display: flex; align-items: center">
            <el-col :span="12">
              <el-tooltip effect="light" :content="mandatory.defineName" placement="top" :disabled="isCanUpdate">
                <el-input
                  v-model="mandatory.defineName"
                  size="small"
                  clearable
                  filterable
                  placeholder="套餐名称"
                  :disabled="!isCanUpdate"
                  @change="everyCheckData()"
                  @blur="checkName"
                  style="width:120px;"
                />
              </el-tooltip>
            </el-col>
          </el-col>
          <el-col class="detail-sub" :span="19">
            <el-col v-for="(subItem, subIndex) in mandatory.tradePerfectScopeDetailList" :key="subIndex">
              <el-col :span="isView?4:3" style="text-align: center">
                <el-select
                  style="width:85px"
                  size="small"
                  filterable
                  v-model="subItem.brandCode"
                  @change="handleBrandChange(mandatory.tradePerfectScopeDetailList[subIndex])"
                  :disabled="!mandatory.canUpdate"
                  placeholder="品牌"
                >
                  <template v-for="(brand, index) in customBrandListCopy">
                    <!-- 正常新增 -->
                    <el-option  :key="index" :label="brand.brandName" :value="brand.brandCode" v-if="mandatory.canUpdate && !brand.isDelBrand"></el-option>
                    <!-- 展示旧数据 -->
                    <el-option  :key="index" :label="brand.brandName" :value="brand.brandCode" v-if="!mandatory.canUpdate"></el-option>
                  </template>
                </el-select>
              </el-col>
              <el-col :span="isView?4:3">
                <el-tooltip effect="light" :content="subItem.subBrandName" placement="top" :disabled="!isView && mandatory.canUpdate">
                <el-select
                  style="width:95px"
                  size="small"
                  filterable
                  v-model="subItem.subBrandCode"
                  placeholder="子品牌"
                  :disabled="!mandatory.canUpdate"
                  @change="everyCheckData()"
                >
                  <el-option
                    v-for="(brand, index) in getSubBrandList(subItem.brandCode)"
                    :key="index"
                    :label="brand.brandName"
                    :value="brand.brandCode"
                  ></el-option>
                </el-select>
                </el-tooltip>
              </el-col>
              <el-col :span="3">
                <el-select
                  v-model="subItem.volume"
                  size="small"
                  placeholder="容量"
                  :disabled="!mandatory.canUpdate"
                  style="width:80px"
                  @change="everyCheckData()"
                >
                  <el-option v-for="item in specList" :key="item.key" :label="item.value" :value="item.key"></el-option>
                </el-select>
              </el-col>
              <el-col :span="3">
                <el-select
                  v-model="subItem.multiPackFlag"
                  size="small"
                  placeholder="是否多联包"
                  :disabled="!mandatory.canUpdate"
                  style="width:80px"
                  @change="flagChange($event, subItem)"
                >
                  <el-option v-for="item in multiPackList" :key="item.key" :label="item.value" :value="item.key"></el-option>
                </el-select>
              </el-col>
              <el-col :span="isView?4:3">
                <el-select
                  v-model="subItem.multiPackSpec"
                  size="small"
                  placeholder="规格"
                  :disabled="(!mandatory.canUpdate) || subItem.multiPackFlag === '0'"
                  style="width:70px"
                  @change="getRowQty($event, subItem)"
                >
                  <el-option v-for="item in multiPackSpecList" :key="item.key" :label="item.value" :value="item.key"></el-option>
                </el-select>
              </el-col>
              <el-col :span="3">
                <el-select
                  v-model="subItem.minDisplayQty"
                  size="small"
                  placeholder="最小陈列件"
                  :disabled="!mandatory.canUpdate"
                  style="width:95px"
                  @change="everyCheckData($event, subItem)"
                >
                  <el-option v-for="item in 30" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </el-col>
              <!-- 排面数 -->
              <el-col :span="isView?3:2" style="text-align: center">{{ subItem.rowQty || '' }}</el-col>
              <el-col :span="4" v-if="isCanUpdate">
                <!-- bu  update时 -->
                <div>
                  <!-- 新增的套餐可修改 -->
                  <div v-if="mandatory.canUpdate">
                    <i
                      class="el-icon-circle-plus icon-size"
                      style="margin-right: 10px;color:#64D795; cursor: pointer;"
                      v-if="subIndex === mandatory.tradePerfectScopeDetailList.length - 1"
                      @click="handleAddSubRow(findIndex(mandatory.sequenceFlag))"
                    ></i>
                    <i class="el-icon-remove icon-size" style="color:#CD1231;cursor: pointer;" @click="handleDeleteSubRow(findIndex(mandatory.sequenceFlag), subIndex)"></i>
                  </div>
                  <!-- v-if="!mandatory.canUpdate&&subIndex===0" -->
                </div>
              </el-col>
            </el-col>
          </el-col>
          <el-col class="checkBox" :span="21">
            <div class="checkBox-title">开放区域:</div>
            <div class="checkBox-main" v-if="isView">
              <div
                style="margin-right:20px;display: inline-block;"
                v-for="reginItem in mandatory.regionList"
                :key="reginItem.orgCode"
              >{{reginItem.orgName}}</div>
            </div>
            <div class="checkBox-main" v-else style="display:flex;align-items: center;">
              <el-checkbox
                class="all color"
                :indeterminate="mandatory.isIndeterminate"
                v-model="mandatory.checkAll"
                @change="handleCheckAllChange($event,index)"
              >{{mandatory.checkAll?'全不选':'全选'}}</el-checkbox>
              <el-checkbox-group v-model="mandatory.regionCodeList" @change="handleCheckedCitiesChange($event,index)">
                <el-checkbox v-for="regionItem in regionListByBu" :label="regionItem.orgCode" :key="regionItem.orgId" @change="cancelDialog(regionItem,index,mandatory.scopeDefineId||'')">{{regionItem.orgName}}{{getDefineCount(mandatory.scopeDefineId, regionItem.orgCode)?'（' + getDefineCount(mandatory.scopeDefineId, regionItem.orgCode) + '）':''}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-col>
          <el-col :span="3">
            <div>
              <el-button :class="!isCanUpdate?'isShow':''" type="danger" plain size="mini" @click="handleDeleteRow(mandatory, findIndex(mandatory.sequenceFlag))">删除</el-button>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="pagination">
        <el-pagination
          background
          :current-page.sync="pageInfo.currentPage"
          :page-size="pageInfo.pageSize"
          layout="total, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <div v-else style="text-align:center">您暂未配置必备品套餐</div>
  </div>
</template>

<script>
// import _ from 'lodash'
import { mapState } from 'vuex'
export default {
  // 必备品相关
  name: 'perfect-theme-config-mandatory',
  props: {
    originThemeDefineDTO: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 匹配的品牌
    customBrandList: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 展示数据
    originInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    primaryData: {
      type: Array,
      default: () => {
        return []
      }
    },
    title: {
      type: String,
      default: ''
    },
    // 用以匹配的数据
    matchInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    regionListByBu: {
      type: Array,
      default: () => {
        return []
      }
    },
    defineCountMap: {
      type: Object,
      default: () => {
        return {}
      }
    },
    regionCancelConfirm: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      pageType: '',
      class: '',
      // mandatoryItemList: [
      //   {
      //     canUpdate: true,
      //     checked: false,
      //     defineName: '必备品套餐1',
      //     tradePerfectScopeDetailList: [
      //       {
      //         brandCode: '',
      //         subBrandCode: '',
      //         volume: '',
      //         minDisplayQty: '',
      //         multiPackFlag: '',
      //         multiPackSpec: '',
      //         rowQty: null
      //       }
      //     ],
      //     regionCodeList: [],
      //     checkAll: false,
      //     sequenceFlag: 1
      //   }
      // ],
      mandatoryItemList: [],
      mandatoryItemListOrigin: [],
      showSubBrandList: [],
      multiPackList: [
        {
          key: '1',
          value: '是'
        },
        {
          key: '0',
          value: '否'
        }
      ],
      pageInfo: {
        currentPage: 1,
        pageSize: 5
      },
      total: 0,
      disabledSelected: false,
      disabledBtn: false,
      checkInfoHint: '',
      packSpecList: [],
      //   搜索
      formDesign: {
        defineName: '',
        stackPackSubBrands: ''
      },
      formSearch: {},
      sequenceFlag: 0,
      customBrandListCopy: []
    }
  },
  watch: {
    regionListByBu: {
      deep: true,
      immediate: true,
      handler () {
        this.mandatoryItemList.forEach((item) => {
          if (item.regionList !== null && item.regionList.length === this.regionListByBu.length) {
            item.checkAll = true
          }
        })
      }
    }
  },
  computed: {
    ...mapState({
      specList: state => state.base.tradePerfectMandatorySpecsMap,
      multiPackSpecList: (state) => {
        return state.base.tradePerfectScopeDetailSpecMap
      }
    }),
    mandatoryItemListPagination () {
      if (!this.mandatoryItemList) return []
      //   搜索筛选 filteredList为筛选过后的数组
      const filteredList = this.mandatoryItemList.filter(item => {
        // 模糊查询
        if (this.formSearch.defineName && item.defineName.toLowerCase().indexOf(this.formSearch.defineName.toLowerCase()) < 0) {
          return false
        }
        if (this.formSearch.stackPackSubBrands) {
          if (!item.tradePerfectScopeDetailList) {
            return false
          }
          const brandArray = item.tradePerfectScopeDetailList.map(item => {
            return item.subBrandCode
          }) || []
          if (brandArray.indexOf(this.formSearch.stackPackSubBrands) < 0) {
            return false
          }
        }
        return true
      })
      this.setTotal(filteredList.length)
      const startIndex = this.pageInfo.pageSize * (this.pageInfo.currentPage - 1)
      const endIndex = this.pageInfo.pageSize * this.pageInfo.currentPage
      return filteredList.slice(startIndex, endIndex)
    },
    subBrandOptions () {
      return this.originThemeDefineDTO.subBrandList
    },
    isCanUpdate () {
      return this.pageType === 'update' || this.pageType === 'config'
    },
    // isUpdate () {
    //   if (this.primaryData.length !== 0) {
    //     return this.$route.query.type === 'update' && this.$route.query.isUpdate === 200
    //   } else {
    //     return false
    //   }
    // },
    getDefineCount () {
      return (scopeDefineId, orgCode) => {
        let key = scopeDefineId + '_' + orgCode
        return this.defineCountMap[key]
      }
    },
    isView () {
      return this.$route.query.type === 'view'
    },
    isSave () {
      return this.$route.query.status === 0 && this.$route.query.type !== 'view'
    }
  },
  created () {
    this.pageType = this.$route.query.type
  },
  methods: {
    // 设置基本信息
    setInfo () {
      this.mandatoryItemList = this.primaryData
      this.customBrandListCopy = Object.assign(this.customBrandListCopy, this.customBrandList)
      this.mandatoryItemList.forEach((item) => {
        if (item.sequenceFlag > this.sequenceFlag) {
          this.sequenceFlag = item.sequenceFlag
        }
        if (item.regionList) {
          item.regionList.forEach((region) => {
            region.orgName = region.orgName.substring(0, region.orgName.indexOf('|'))
          })
        }

        this.$set(item, 'checkAll', false)
        this.$set(item, 'regionCodeList', item.regionCodes ? item.regionCodes.split(',') : [])
      })
      this.getDelBrandList()
    },
    // setData () {
    //   this.disabledSelected = false // bu trun
    //   this.disabledBtn = false // bu trun
    //   // 货架/冰柜必备品定义
    //   if (this.pageType === 'config') {
    //     // 新建
    //     if (this.originInfo.mandatoryScopeList) {
    //       this.mandatoryItemList = _.cloneDeep(
    //         this.originInfo.mandatoryScopeList
    //       )
    //     } else {
    //       this.mandatoryItemList = this.$options.data().mandatoryItemList
    //     }
    //     this.mandatoryItemList.map(item => {
    //       this.$set(item, 'checked', false)
    //       this.$set(item, 'regionCodeList', [])
    //     })
    //     this.mandatoryItemListOrigin = _.cloneDeep(this.mandatoryItemList)
    //   } else if (this.pageType === 'update') {
    //     // 修改
    //     this.mandatoryItemList =
    //       _.cloneDeep(this.matchInfo.mandatoryScopeList) ||
    //       this.$options.data().mandatoryItemList
    //     this.mandatoryItemList.map(item => {
    //       this.$set(item, 'regionCodeList', [])
    //       this.$set(item, 'checkAll', false)
    //       item.regionCodeList = item.regionCodes ? item.regionCodes.split(',') : []
    //     })
    //   }
    // },
    // 获取分页后 元素在数组中的实际index
    getIndex (index) {
      return (this.pageInfo.currentPage - 1) * this.pageInfo.pageSize + index
    },
    findIndex (sequenceFlag) {
      let sIndex = 0
      this.mandatoryItemList.forEach((item, index) => {
        if (item.sequenceFlag === sequenceFlag) {
          sIndex = index
        }
      })
      console.log(sIndex)
      return sIndex
    },
    setTotal (total) {
      this.total = total
    },
    // 搜索
    onSubmit () {
      this.formSearch = JSON.parse(JSON.stringify(this.formDesign))
      this.pageInfo.currentPage = 1
    },
    // 重置
    handleResst () {
      this.formDesign = {
        defineName: '',
        stackPackSubBrands: ''
      }
      this.formSearch = {
        defineName: '',
        stackPackSubBrands: ''
      }
    },
    // 新增套餐
    handleAddRow () {
      if (!this.checkNameData()) {
        this.$message.warning(`套餐类型名称 ${this.checkInfoHint} 重复`)
        return
      }
      this.sequenceFlag = 0
      this.mandatoryItemList.forEach((item) => {
        if (item.sequenceFlag > this.sequenceFlag) {
          this.sequenceFlag = item.sequenceFlag
        }
      })
      this.formSearch = {}
      this.sequenceFlag++
      const cityOptions = this.regionListByBu.map(item => {
        return item.orgCode
      })
      let obj = {
        checked: false,
        defineName: '必备品套餐' + this.sequenceFlag,
        tradePerfectScopeDetailList: [
          {
            brandCode: '',
            subBrandCode: '',
            volume: '',
            minDisplayQty: '',
            multiPackFlag: '',
            multiPackSpec: '',
            rowQty: null
          }
        ],
        regionCodeList: cityOptions,
        checkAll: true,
        sequenceFlag: this.sequenceFlag
      }
      if (this.isCanUpdate) {
        obj.canUpdate = true
      }
      obj.canUpdate = true // 暂时修改
      this.mandatoryItemList.unshift(obj)
    },
    // 新增子套餐
    handleAddSubRow (index) {
      let subIndex = this.mandatoryItemList[index].tradePerfectScopeDetailList.length
      this.$set(this.mandatoryItemList[index].tradePerfectScopeDetailList, subIndex, {
        brandCode: '',
        subBrandCode: '',
        volume: '',
        minDisplayQty: '',
        multiPackFlag: '',
        multiPackSpec: '',
        rowQty: null
      })
    },
    // 删除子套餐
    handleDeleteSubRow (index, subindex) {
      this.$confirm('是否确认删除该条配置', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.mandatoryItemList[index].tradePerfectScopeDetailList.length === 1) {
          this.mandatoryItemList.splice(index, 1)
        } else {
          this.mandatoryItemList[index].tradePerfectScopeDetailList.splice(subindex, 1)
        }
      }).catch(() => { })
    },
    // 删除套餐
    handleDeleteRow (mandatory, index) {
      let message = '是否确认删除该套餐'
      if (this.mandatoryItemList[index].scopeDefineId && this.$route.query.status !== 0) {
        message = '若删除该套餐，则选择该套餐的活动都会被禁用！'
      }
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.mandatoryItemList.splice(index, 1)
        })
        .catch(() => { })
    },

    // handleReset () {
    //   this.setData()
    // },
    // 更改主品牌 清空子品牌
    handleBrandChange (item) {
      item.subBrandCode = ''
      this.everyCheckData()
    },
    // 根据是否多联包展示对应规格
    flagChange (e, subItem) {
      if (e === '1') {
        subItem.multiPackSpec = ''
      } else {
        subItem.multiPackSpec = '1*1'
      }
      this.getRowQty(e, subItem)
    },
    // 展示联动的子品牌列表
    getSubBrandList (parentBrandCode) {
      let arr = []
      if (this.customBrandListCopy.length) {
        this.customBrandListCopy.forEach(item => {
          if (parentBrandCode === item.brandCode) {
            arr = [...arr, ...item.subBrandList]
          }
        })
      }
      let obj = {}
      arr = arr.reduce(function (pre, item) {
        // eslint-disable-next-line no-unused-expressions
        obj[item.brandCode] ? '' : obj[item.brandCode] = true && pre.push(item)
        return pre
      }, [])
      return arr
    },

    // 必备品 每次改动的校验
    everyCheckData (e, subItem) {
      if (e) {
        this.getRowQty(e, subItem)
      }
      this.checkInfoHint = ''
      if (!this.checkNameData()) {
        this.$message.warning(`套餐类型名称 ${this.checkInfoHint} 重复`)
        return false
      }

      if (!this.checkInsideData()) {
        this.$message.warning(`套餐 ${this.checkInfoHint} 内部数据重复`)
        return false
      }

      // 套餐内每个数据都填完，才去校验套餐之间
      // ----------------------------
      let allList = Object.assign([], this.mandatoryItemList)
      let canCheck = true
      if (allList.length > 1) {
        allList.forEach(mandatory => {
          if (mandatory.tradePerfectScopeDetailList.length) {
            mandatory.tradePerfectScopeDetailList.forEach(item => {
              if (!item.brandCode || !item.subBrandCode || !item.minDisplayQty || !item.volume || !item.multiPackFlag || !item.multiPackSpec) {
                canCheck = false
              }
            })
          }
        })
      }
      // -----------------------------
      if (canCheck && !this.checkBrotherData()) {
        // this.$message.warning('套餐之间数据重复')
        this.$message.warning(`套餐 ${this.checkInfoHint} 之间数据重复`)
        return false
      }
      return true
    },

    // 套餐类型名称 name
    checkNameData () {
      let checkedResult = true
      let allList = Object.assign([], this.mandatoryItemList)
      let nameArr = []
      let sameObj = {}

      if (allList.length > 1) {
        allList.forEach(mandatory => {
          nameArr.push(mandatory.defineName)
        })
      }

      sameObj = this.sortCheckSame(nameArr)

      checkedResult = sameObj.checkedResult
      this.checkInfoHint = checkedResult ? '' : sameObj.hint

      return checkedResult
    },

    // 套餐内部校验 brand subBrand spec
    checkInsideData () {
      let checkedResult = true
      let allList = Object.assign([], this.mandatoryItemList)

      if (allList.length) {
        for (let i = 0; i < allList.length; i++) {
          // 每个套餐
          let itemArr = allList[i].tradePerfectScopeDetailList
          let itemName = allList[i].defineName
          let insideStrArr = []

          if (itemArr.length) {
            itemArr.forEach(itemInfo => {
              // 每个套餐内部
              if (itemInfo.brandCode && itemInfo.subBrandCode && itemInfo.volume) {
                let itemStr = itemInfo.brandCode + ',' + itemInfo.subBrandCode + ',' + itemInfo.volume + ',' + itemInfo.multiPackSpec
                insideStrArr.push(itemStr)
              }
            })
          }
          // insideStrArr 内部如 ["ISP,20AHME01,bigCan", "ISP,20AHME01,BBT"]
          checkedResult = this.sortCheckSame(insideStrArr).checkedResult
          if (!checkedResult) {
            this.checkInfoHint = itemName
            break
          }
        }
      }
      return checkedResult
    },

    // 套餐之间校验  brand subBrand spec qty
    checkBrotherData () {
      let checkedResult = true
      let allList = Object.assign([], this.mandatoryItemList)

      if (allList.length > 1) {
        let allStrList = []
        let itemNameList = []
        let sameObj = {}

        for (let i = 0; i < allList.length; i++) {
          // 每个套餐
          let itemArr = allList[i].tradePerfectScopeDetailList
          itemNameList.push(allList[i].defineName)

          let insideStrArr = []

          if (itemArr.length) {
            itemArr.forEach(itemInfo => {
              // 每个套餐内部
              let str = itemInfo.brandCode + ',' + itemInfo.subBrandCode + ',' + itemInfo.volume + ',' + itemInfo.minDisplayQty + ',' + itemInfo.multiPackFlag + ',' + itemInfo.multiPackSpec
              insideStrArr.push(str)
            })
          }

          // allSrtList 内部如 ["["20ABZY,20ABZY10,bigCan,3","20ACKF,20ACKF15,bigCan,3"]", "["20ABZY,20ABZY10,bigCan,3"]"]
          allStrList.push(JSON.stringify(insideStrArr.sort()))
        }

        sameObj = this.sortCheckSame(allStrList)
        checkedResult = sameObj.checkedResult
        if (!checkedResult) {
          let index1 = allStrList.indexOf(sameObj.hint)
          let index2 = allStrList.indexOf(sameObj.hint, (index1 + 1))
          this.checkInfoHint = itemNameList[index1] + '与' + itemNameList[index2]
        }
      }

      return checkedResult
    },

    // 排序查重
    sortCheckSame (checkArr) {
      let arr = Object.assign([], checkArr)
      let checkedResult = true
      let hint = ''

      if (arr.length) {
        let sortArr = arr.sort()
        for (let i = 0; i < sortArr.length; i++) {
          if (sortArr[i] === sortArr[i + 1]) {
            hint = sortArr[i]
            checkedResult = false
            break
          }
        }
      }

      // return checkedResult
      return { checkedResult, hint }
    },

    // 主组件校验
    checkData (status) {
      let checkedResult = true
      if (this.mandatoryItemList.length) {
        // 判断主数据不能为空
        this.mandatoryItemList.forEach((item) => {
          checkedResult = checkedResult && item.defineName
          if (status) {
            checkedResult = checkedResult && item.regionCodeList.length
          }
        })
        // tradePerfectScopeDetailList校验
        let arr = []
        this.mandatoryItemList.forEach(mandatory => {
          if (mandatory.tradePerfectScopeDetailList.length) {
            mandatory.tradePerfectScopeDetailList.forEach(item => {
              arr.push(item)
            })
          }
        })
        if (arr.length) {
          checkedResult = arr.every(item => {
            return Boolean(
              item.brandCode && item.subBrandCode && item.volume && item.minDisplayQty && item.multiPackFlag && item.multiPackSpec
            )
          })
        }
        // bu 必备品内部数据校验
        if (checkedResult && !this.everyCheckData()) {
          checkedResult = false
        }
      }
      if (!checkedResult) {
        this.$message.warning({
          message: '请正确配置“' + this.title + '”部分数据',
          duration: 8000
        })
      }
      return checkedResult
    },

    checkName (e) {
      if (e && !e.target.value) {
        this.$message.warning('必备品/排面数套餐名称不能为空')
      }
    },

    // 计算排面数
    getRowQty (e, subItem) {
      subItem.rowQty = null
      if (subItem.multiPackSpec && subItem.minDisplayQty) {
        let specList = subItem.multiPackSpec.split('*')
        specList.sort((a, b) => {
          return Number(b) - Number(a)
        })
        subItem.rowQty = Number(specList[0]) * subItem.minDisplayQty
      }
    },
    // 多选
    handleCheckAllChange (val, index) {
      const cityOptions = this.regionListByBu.map(item => {
        return item.orgCode
      })
      if (val) {
        this.mandatoryItemListPagination[index].regionCodeList = cityOptions
        return
      }
      if (this.regionCancelConfirm) {
        this.mandatoryItemListPagination[index].checkAll = true
        this.$confirm('若取消区域，则区域选择了此任务的活动都会被禁用！', '是否取消开放该区域', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          this.mandatoryItemListPagination[index].regionCodeList = []
          this.mandatoryItemListPagination[index].checkAll = false
        }).catch(() => {
          this.mandatoryItemListPagination[index].regionCodeList = cityOptions
          this.mandatoryItemListPagination[index].checkAll = true
        })
      } else {
        this.mandatoryItemListPagination[index].regionCodeList = []
      }
    },
    handleCheckedCitiesChange (value, index) {
      let arr = this.regionListByBu.filter((item, index) => {
        let flag = false
        value.forEach((sItem, sIndex) => {
          if (item.orgCode === sItem) {
            flag = true
          }
        })
        return flag
      })
      this.mandatoryItemListPagination[index].regionCodeList = arr.map((item, index) => item.orgCode)
      let checkedCount = value.length
      this.mandatoryItemListPagination[index].checkAll = checkedCount === this.regionListByBu.length
      this.mandatoryItemListPagination[index].isIndeterminate = checkedCount > 0 && checkedCount < this.regionListByBu.length
    },
    // region单选取消弹窗
    cancelDialog (item, index, scopeDefineId) {
      let message = ''
      let key = scopeDefineId + '_' + item.orgCode
      if (this.defineCountMap[key] !== undefined) {
        message = '此任务已被该区域的' + this.defineCountMap[key] + '个活动引用，'
      }
      if (this.mandatoryItemListPagination[index].regionCodeList.indexOf(item.orgCode) === -1 && this.regionCancelConfirm) {
        this.$confirm(message + '若取消区域，则区域选择了此任务的活动都会被禁用！', '是否取消开放该区域', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          // this.$message.success('已取消')
        }).catch(() => {
          this.mandatoryItemListPagination[index].regionCodeList.push(item.orgCode)
        })
      }
    },
    getMandatoryInfo (taskType) {
      let params = this.mandatoryItemList.map(item => {
        return {
          scopeDefineId: item.scopeDefineId,
          defineType: '03',
          taskType: taskType,
          defineName: item.defineName,
          regionCodes: item.regionCodeList.join(','),
          sequenceFlag: item.sequenceFlag,
          tradePerfectScopeDetailList: item.tradePerfectScopeDetailList
        }
      })
      return params
    },
    // 完美门店2.0 部分品牌删除 兼容处理
    getDelBrandList () {
      this.mandatoryItemList.forEach(item => {
        item.tradePerfectScopeDetailList.forEach(taskItem => {
          let obj = {
            brandCode: taskItem.brandCode,
            brandName: taskItem.brandName,
            subBrandCode: taskItem.subBrandCode,
            subBrandName: taskItem.subBrandName,
            subBrandList: [taskItem.subBrandDTO],
            isDelBrand: true
          }
          // this.customBrandListCopy.push(obj)
          this.$set(this.customBrandListCopy, this.customBrandListCopy.length, obj)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.require {
  position: relative;
  &::before {
    content: '*';
    font-size: 20px;
    width: 5px;
    height: 5px;
    color: red;
    position: absolute;
    top: -10px;
    left: -10px;
  }
}
.wrapper {
  position: relative;
  background-color: #fff;
  // height: 800px;
  .content {
    display: flex;
    justify-content: flex-start;
    line-height: 50px;
    color: #333;
    transition: height 0.5s;
    .title {
      display: flex;
      flex: none;
      width: 100%;
      // flex-basis: 14%;
      font-size: 16px;
      font-weight: 600;
      justify-content: space-between;
      div {
        // width: 100%;
        text-align: right;
      }
      .el-button {
        display: inline-block;
        padding: 7px 20px;
      }
    }
  }
  .info {
    position: relative;
    // min-height: 700px;
    .header {
      line-height: 40px;
      border-radius: 5px;
      background: #eee;
    }
    .el-col {
      text-align: center;
    }
    .detail {
      flex-wrap: wrap;
      border-bottom: 1px solid #ccc;
      // min-height: 120px;
      // line-height: 120px;
      padding: 20px 0;
      .detail-sub {
        line-height: 50px;
      }
      .region-wrapper {
        line-height: 30px;
        text-align: left;
        padding: 10px 0;
      }
      .design-thumbnail {
        width: 100%;
        height: 100%;
        cursor: pointer;
        .design-thumbnail-column {
          display: inline-block;
        }
        .design-thumbnail-row {
          box-sizing: border-box;
          width: 25px;
          height: 25px;
          border: 1px solid #c0c4cc;
          border-radius: 3px;
        }
      }
      .design {
        text-align: center;
        .design-img {
          display: flex;
          flex-wrap: wrap;
          height: 100px;
          width: 100px;
          margin: 0 auto;
          // border: 1px solid #C0C4CC;
          border-radius: 8px;
          div {
            box-sizing: border-box;
            display: inline-block;
            border: 1px solid #c0c4cc;
            border-radius: 3px;
          }
        }
      }
    }
  }
  .card-wraper {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none;
  }
  .box-card {
    // width: 700px;
    pointer-events: auto;
    z-index: 2;
    .card-header {
      text-align: center;
      line-height: 40px;
      font-size: 18px;
      font-weight: 600;
      color: #333;
      span {
        display: inline-block;
        width: 50%;
      }
    }
    .card-select {
      display: flex;
      flex-wrap: nowrap;
      overflow-x: scroll;
      padding-bottom: 10px;
      // min-width: 350px;
    }
  }
  .card-item {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 100px;
    height: 80px;
    margin: 10px auto 0;
    text-align: center;
    color: #fff;
    border: 1px solid #c0c4cc;
    border-radius: 10px;
  }
  .card-operte {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
  }
  .pagination {
    text-align: center;
    padding: 20px 0;
  }
}
.el-select {
  width: 120px;
}
.isShow {
  display: none;
}
.iptSize {
  margin-right: 10px;
}
.detail-item-brand {
  height: 32px;
  line-height: 32px;
  margin-top: 8.5px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
  width: 80px;
  color: #c0c4cc;
  font-size: 13px;
  box-sizing: border-box;
  padding: 0 5px;
  text-align: left;
  overflow: hidden;
  cursor: not-allowed;
}
// 开放区域
.checkBox {
  margin-top: 10px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #606266;
  .checkBox-title {
    flex-basis: 10%;
  }
  .checkBox-main {
    flex-basis: 90%;
  }
}
.all {
  padding: 0 20px 0 10px;
}
.color {
  color: #409eff !important;
}
.icon-size {
  font-size: 22px;
}
::v-deep .all .el-checkbox__inner {
  display: none;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #409eff;
  border-color: #409eff;
}
.wrapper .info .checkBox {
  text-align: left;
  padding-left: 100px;
}
</style>
